export function clampLegalReadingProgress(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.min(100, Math.max(0, value));
}

export function calculateLegalReadingProgress(
  scrollTop: number,
  scrollHeight: number,
  clientHeight: number,
): number {
  if (![scrollTop, scrollHeight, clientHeight].every(Number.isFinite)) return 0;
  const maxScrollTop = scrollHeight - clientHeight;
  if (maxScrollTop <= 0) return 0;
  return clampLegalReadingProgress((scrollTop / maxScrollTop) * 100);
}
